var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostureResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5356 14.463C12.3566 13.9566 10.6318 12.1681 10.2014 9.9728C9.91163 8.49504 10.186 7.09494 10.8423 5.93931C10.9438 5.76065 10.7713 5.55472 10.5737 5.61102C7.59531 6.45972 5.46419 9.3179 5.74624 12.628C6.01434 15.7744 8.55138 18.3655 11.6921 18.6929C14.8737 19.0246 17.6549 17.1223 18.6768 14.365C18.7483 14.172 18.5601 13.9806 18.3739 14.0684C17.2464 14.6005 15.9242 14.7857 14.5356 14.463Z",
    fill: "#0D212C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.895 3.01562H22.6545L18.9616 6.70851H22.6545",
    stroke: "#0D212C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2312 7.47266H16.2998L13.2856 10.4869H16.2998",
    stroke: "#0D212C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.9096 9.77698C22.0771 10.4911 22.1657 11.2357 22.1657 12.0009C22.1657 17.3582 17.8228 21.7011 12.4655 21.7011C7.10829 21.7011 2.76538 17.3582 2.76538 12.0009C2.76538 6.64369 7.10829 2.30078 12.4655 2.30078C13.8779 2.30078 15.2197 2.60263 16.4301 3.14532",
    stroke: "#0D212C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureResting);
export default __webpack_public_path__ + "static/media/PostureResting.af264f3c22acd45d22be35ae20fdf248.svg";
export { ForwardRef as ReactComponent };